export const BankName = {
  ABAY: "abay",
  ABYSSINIA: "abyssinia",
  BUNNA:"bunna",
  AWASH:"awash"
};
